const subTasksEnumerators = {
  status: [
    'open',
    'in_progress',
    'stuck',
    'closed',
  ],
}

export default subTasksEnumerators
